import { Card, Flex, Heading, Tag, Text } from '@chakra-ui/react';
import { useNavigate } from 'react-router';
import { toast } from 'react-toastify';
import { datadogRum } from '@datadog/browser-rum';
import api from '@services/api';

import type { InteractionCardType } from '../types';

type Props = {
  interaction: InteractionCardType,
};

const InteractionCard = ({ interaction }: Props) => {
  const navigate = useNavigate();
  const isWalkIn = interaction.campaign_execution_id == null;

  const onClickCard = async () => {
    try {
      const response = await api.get(`/customer_interaction/${interaction.id}`);

      if (response.status === 200) {
        navigate('/painel/meus-atendimentos/cliente', {
          state: {
            customer: response.data.customer,
            customerInteractionId: response.data.id,
            dispositions: response.data.dispositions,
            funnelId: response.data.sales_funnel_step_id,
          },
        });
      }
    } catch (error) {
      toast.error('Erro ao abrir atendimento');
      datadogRum.addError(new Error('Fail to open customer interaction'), {
        error,
        customerInteractionId: interaction.id,
      });
    }
  };

  return (
    <Card.Root
      size="sm"
      variant="elevated"
      bg="grayscale.fg"
      p={3}
      _hover={{ bg: 'bg.subtle' }}
      cursor="pointer"
      onClick={onClickCard}
    >
      <Flex alignItems="center" justifyContent="space-between" gap={2} mb={1}>
        <Heading size="sm" color="fg.default" truncate>
          {interaction.customer.name}
        </Heading>
        <Tag.Root size="sm" colorPalette={isWalkIn ? 'blue' : 'green'} flexShrink={0}>
          <Tag.Label>{isWalkIn ? 'Avulso' : 'Campanha'}</Tag.Label>
        </Tag.Root>
      </Flex>

      <Text color="fg.muted" fontSize="xs" mb={interaction.customer.tags.length > 0 ? 2 : 0}>
        {interaction.customer.portfolio?.name}
      </Text>

      <Flex gap={1} flexWrap="wrap">
        {interaction.customer.tags.map((tag) => (
          <Tag.Root key={tag} size="sm" bg="argos.fg" color="grayscale" fontWeight={600}>
            <Tag.Label>{tag}</Tag.Label>
          </Tag.Root>
        ))}
      </Flex>
    </Card.Root>
  );
};

export default InteractionCard;
